module.exports = __webpack_public_path__ + "static/img/lotte-rental.65bad8d.gif";


//////////////////
// WEBPACK FOOTER
// ./static/img/partner/lotte-rental.gif
// module id = i+39
// module chunks = 0